import React, { useState } from 'react'
import ShoesByCategory from './ShoesByCategory/ShoesByCategory'
import FindYourStyleMainSection from './FindYourStyleMainSection'

export default function FindYourStyle(props) {
  const { PageDataFun, viewPage, selectedStyle, setMenStyleData } = props
  const [viewsubPage, setsubPage] = useState('FindYourStyle')
  return (
    <>
      {/* {viewsubPage === 'FindYourStyle' && ( */}
      <FindYourStyleMainSection
        PageDataFun={PageDataFun}
        setsubPage={setsubPage}
        selectedStyle={selectedStyle}
        setMenStyleData={setMenStyleData}
      />
      {/* )} */}
      {/* {viewsubPage === 'ShoesByCategory' && <ShoesByCategory setsubPage={setsubPage} />} */}
    </>
  )
}
